'use strict';

/**
 *
 * @name: apiCommentsService
 *
 */

function ApiCommentsService(
  $rootScope,
  $http
) {

  'ngInject';

  /**
   *
   * @PUBLIC
   *
   */

  function deleteComment(commentId) {

    var target = $rootScope.apiUrlNew + '/post-comment/' + commentId;

    return $http.delete(target);
  }

  function downvote(commentId) {

    var target = $rootScope.apiUrlNew + '/post-comment/' + commentId + '/downvote';

    return $http.put(target);
  }

  function getComments(postId, page, limit) {

    var target = $rootScope.apiUrlNew + '/post-comment?' +
      '&PostId=' + postId + '&order=votes desc,createdAt desc' +
      '&page=' + (page ? page : 1) +
      '&limit=' + (limit ? limit : 11);

    return $http.get(target);
  }

  function postComment(comment) {

    var target = $rootScope.apiUrlNew + '/post-comment';

    return $http.post(target, comment);
  }

  function upvote(commentId) {

    var target = $rootScope.apiUrlNew + '/post-comment/' + commentId + '/upvote';

    return $http.put(target);
  }

  /**
   *
   * @PRIVATE
   *
   */

  return {

    deleteComment: deleteComment,
    downvote: downvote,
    getComments: getComments,
    postComment: postComment,
    upvote: upvote,
  };
}

export default ApiCommentsService;



// WEBPACK FOOTER //
// ./app/components/_api/comments.service.js